<template>
  <b-form @submit="handleSubmit">
    <b-form-group label="First Name" label-class="text-truncate label-required" v-if="userAttributes.includes('lastName')">
      <b-form-input v-model="firstName" required/>
    </b-form-group>

    <b-form-group label="Last Name" label-class="text-truncate label-required" v-if="userAttributes.includes('firstName')">
      <b-form-input v-model="lastName" required/>
    </b-form-group>

    <b-form-group label="Job Title" label-class="text-truncate label-required" v-if="userAttributes.includes('jobTitle')">
      <b-form-input v-model="jobTitle" required/>
    </b-form-group>

    <b-row class="mt-4 mb-2">
      <b-col class="ml-auto" cols="auto">
        <b-button variant="light"
                  class="btn-rounded px-3"
                  @click="$emit('cancel')"
                  :disabled="saving">
          Cancel
        </b-button>
        <b-button variant="primary"
                  class="btn-rounded px-3"
                  type="submit"
                  :disabled="saving">
          <span v-if="saving">Please Wait...</span>
          <span v-else>Save</span>
        </b-button>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import GeneralMixins from "../../../mixins/GeneralMixins.js";
import CustomerEditProfileInfo from "../Account/EditProfileInfo.vue";
import {UsersApi} from "../../Api/UsersApi.js";

export default {
  components: {CustomerEditProfileInfo},
  mixins: [GeneralMixins],
  props: {
    userAttributes: {
      type: Array,
      required: true
    }
  },

  data: function () {
    return {
      saving: false,
      user: null,
      lastName: null,
      firstName: null,
      jobTitle: null
    }
  },

  mounted() {
    UsersApi.getCurrentUser().then(user => {
      this.user = user;
      this.firstName = user.first_name;
      this.lastName = user.last_name;
      this.jobTitle = user.job_title;
    }).catch(error => {
      this.showErrorToast(this.getErrorMessages(error, true))
    })
  },

  methods: {
    handleSubmit(evt) {
      evt.preventDefault();
      this.saving = true;
      UsersApi.updateUser(this.params).then(fulfilled => {
        this.$emit('saved');
        this.saving = false;
      }, rejected => {
        this.saving = false;
        this.showErrorToast(this.getErrorMessages(rejected.body, true))
      })
    }
  },

  computed: {
    params() {
      let params = {};

      if (this.userAttributes.includes('firstName')) {
        params.first_name = this.firstName;
      }
      if (this.userAttributes.includes('lastName')) {
        params.last_name = this.lastName;
      }
      if (this.userAttributes.includes('jobTitle')) {
        params.job_title = this.jobTitle;
      }

      return params;
    },
  }
}
</script>